import { LoginFlowVariant } from '@/store/authentication/AuthenticationStore';

enum StorageKeys {
  CookiesConsent = 'LD_COOKIES_CONSENT',
  ReturningUser = 'LD_RETURNING_USER',
  RewardsWheelReminder = 'LD_REWARDS_WHEEL_REMINDER',
  SidebarCollapsed = 'LD_SIDEBAR_COLLAPSED',
}

export enum ReturningUserLoginMethod {
  Email = 'EMAIL',
  Mobile = 'MOBILE',
}

const StorageManager = {
  getCookiesConsent: (): { accepted: boolean; performance: boolean } => {
    const current = localStorage.getItem(StorageKeys.CookiesConsent);
    if (!current) {
      return { accepted: false, performance: false };
    }
    const toJson = JSON.parse(current);
    return { accepted: toJson.accepted, performance: toJson.performance };
  },
  saveCookiesConsent: (accepted: boolean, performance: boolean) => {
    const toSave = JSON.stringify({ accepted, performance });
    localStorage.setItem(StorageKeys.CookiesConsent, toSave);
  },
  setIsReturningUser: (loginMethod: ReturningUserLoginMethod) =>
    localStorage.setItem(StorageKeys.ReturningUser, loginMethod),
  getIsReturningUser: (): LoginFlowVariant | null => {
    const value = localStorage.getItem(StorageKeys.ReturningUser);
    if (!value) {
      return null;
    }
    /** this code is written like this because we've used the value 'true' before to
     * differentiate between returning/new customer, now we want to further differentiate
     * by the login method used (email/mobile), that's why we are defaulting 'true' to Email
     */
    if (value === ReturningUserLoginMethod.Mobile) {
      return LoginFlowVariant.Mobile;
    }

    return LoginFlowVariant.Email;
  },
  setRewardsReelReminder: () =>
    localStorage.setItem(StorageKeys.RewardsWheelReminder, new Date().toISOString()),
  getRewardsWheelReminder: () => localStorage.getItem(StorageKeys.RewardsWheelReminder),
  setSidebarCollapsed: (collapsed: 'true' | 'false') =>
    localStorage.setItem(StorageKeys.SidebarCollapsed, collapsed),
  getSidebarCollapsed: () => localStorage.getItem(StorageKeys.SidebarCollapsed),
};

export default StorageManager;
